import SvgIcon from "@/components/SvgIcon/index.vue"

export default (vue) => {
    vue.component('svg-icon', SvgIcon)
    // 统一批量引入
    const req = require.context('./svg', false, /\.svg$/) // ./svg -> svg文件所在路径
    const requireAll = requireContext => requireContext.keys().map(requireContext)
    requireAll(req)
}
